import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import styles from "./HomeIntroHero.module.css";
import { IHomeAboutSectionProps } from "@model/Home.model";
import { useMotion } from "../../../Logic/Functions/Hooks/useMotion";

const HomeAboutSection: React.FC<IHomeAboutSectionProps> = ({
  brands,
  once = false,
  triggerAmount = 0.25,
}) => {
  const navigate = useNavigate();
  const { slideFade, containerStagger } = useMotion();

  if (!brands.length) return null;

  const handleAboutClick = () => {
    navigate("/about");
  };

  return (
    <motion.section
      className={styles.HASection}
      aria-labelledby="home-about-title"
      data-testid="home-about-section"
      variants={slideFade("up", 0)}
      initial="hidden"
      whileInView="show"
      viewport={{ once, amount: triggerAmount }}
    >
      <div className={styles.HAHeader}>
        <div className={styles.HATextBlock}>
          <h2 id="home-about-title" className={styles.HATitle}>
            About Chimera
          </h2>
          <p className={styles.HASubtitle}>
          Chimera is built for people who want their space to feel smarter, calmer, and more personal.
          </p>
          <p className={styles.HASubtitle}>We create automation experiences that blend quietly into daily life, making comfort easier, control simpler, and everymoment at home feel more intentional.</p>
        </div>

        <button
          type="button"
          className={styles.HAAboutBtn}
          onClick={handleAboutClick}
          data-testid="home-about-button"
        >
          About us
        </button>
      </div>

      <motion.div
        className={styles.HABrandsShell}
        variants={slideFade("up", 0.05)}
      >
        <div className={styles.HABrandsHeaderRow}>
          <span className={styles.HABrandsLabelLeft}>
            Trusted brands &amp; technologies
          </span>
          <span className={styles.HABrandsLabelRight}>
            Certified &amp; compatible partners
          </span>
        </div>

        <motion.div
          className={styles.HABrandsGrid}
          variants={containerStagger(0.12)}
          data-testid="home-about-brands-grid"
        >
          {brands.map((brand, i) => (
            <motion.article
              key={brand.id}
              className={styles.HABrandCard}
              data-testid="home-about-brand-card"
              variants={slideFade("up", 0.04 * i)}
            >
              <img
                src={brand.logoUrl}
                alt={brand.name}
                className={styles.HABrandLogo}
                loading="lazy"
              />
            </motion.article>
          ))}
        </motion.div>
      </motion.div>
    </motion.section>
  );
};

export default HomeAboutSection;
